import React, { useState } from "react";
import {
  BaseBox,
  BaseTypography,
  BaseTextField,
  BaseButton,
} from "../../../Common/UI/exports";
import { generateKey } from "../../../Utils/CryptoUtils";

function Keys() {
  const email = localStorage.getItem("email");

  const [inputData, setInputData] = useState("");
  const [outputData, setOutputData] = useState("");

  const handleAction = async (action) => {
    try {
      let result;

      switch (action) {
        case "generate-crypto-key":
          result = generateKey();
          break;
        default:
          return;
      }

      console.log(result);
      setOutputData(result);
    } catch (err) {
      console.error(err);
      setOutputData({ error: err.response?.data || err.message });
    }
  };

  return (
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          Crypto Keys Generator
        </BaseTypography>

        <BaseBox
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          {/* Output */}
          <BaseTextField
            label="Output"
            value={outputData || ""}
            fullWidth
            multiline
            rows={6}
          />
          {/* Buttons */}
          <BaseBox sx={{ display: "flex", gap: 2 }}>
            <BaseButton
              onClick={() => handleAction("generate-crypto-key")}
              color="info"
            >
              Generate Crypto Key
            </BaseButton>
          </BaseBox>
        </BaseBox>
      </BaseBox>
  );
}

export default Keys;
